const HEX = /^[0-9a-fA-F]+$/;
const IV_LENGTH = 32;

export const isEncryptedUserId = (value) => {
  if (typeof value !== "string" || !value) {
    return false;
  }
  const parts = value.split(":");
  if (parts.length !== 2) {
    return false;
  }
  const iv = parts[0];
  const encryptedText = parts[1];
  if (iv.length !== IV_LENGTH || encryptedText.length === 0) {
    return false;
  }
  return HEX.test(iv) && HEX.test(encryptedText);
};

export const resolveDomainSignInUserId = (uidFromQuery, storedGuestUserId) => {
  if (isEncryptedUserId(uidFromQuery)) {
    return uidFromQuery;
  }
  if (isEncryptedUserId(storedGuestUserId)) {
    return storedGuestUserId;
  }
  return undefined;
};

export const buildDomainSignInData = (host, userId) => {
  if (!userId) {
    return { name: host };
  }
  return { name: host, user: { id: userId } };
};
